import { getTeamPhoneNumber } from "@redotech/redo-merchant-marketing-rpc/schema/get-team-phone-number-schema";
import { createSmsSignupTemplates } from "@redotech/redo-merchant-marketing-rpc/schema/sms-template/create-sms-signup-template";
import { createSmsTemplate } from "@redotech/redo-merchant-marketing-rpc/schema/sms-template/create-sms-template";
import { deleteSmsTemplate } from "@redotech/redo-merchant-marketing-rpc/schema/sms-template/delete-sms-template";
import { createContentGeneratorConfig } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/create-content-generator-config";
import { createScenario } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/create-scenario";
import { deleteScenario } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/delete-scenario";
import { generateSmsAiContentPreview } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/generate-sms-ai-content-preview";
import { getContentGeneratorConfigPopulated } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/get-content-generator-config-populated";
import { getSmsTemplateAiOptions } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/get-sms-template-ai-options";
import { getSmsTemplateById } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/get-sms-template-by-id";
import { getSmsTemplateByIdPopulated } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/get-sms-template-by-id-populated";
import { paginateSmsTemplates } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/paginate-sms-templates";
import { publishContentGeneratorConfig } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/publish-content-generator-config";
import { sendTestSMSById } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/send-test-sms-by-id";
import { updateScenario } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/update-scenario";
import { updateSmsTemplate } from "@redotech/redo-merchant-marketing-rpc/schema/sms-templates/update-sms-template";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

export const rpcDefinition = {
  createContentGeneratorConfig,
  createScenario,
  createSmsSignupTemplates,
  createSmsTemplate,
  deleteScenario,
  deleteSmsTemplate,
  generateSmsAiContentPreview,
  getContentGeneratorConfigPopulated,
  getSmsTemplateAiOptions,
  getSmsTemplateById,
  getSmsTemplateByIdPopulated,
  getTeamPhoneNumber,
  paginateSmsTemplates,
  publishContentGeneratorConfig,
  sendTestSMSById,
  updateScenario,
  updateSmsTemplate,
};

export type RedoMerchantSmsTemplatesRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
